import { set_ui_settings } from 'console/redux/settings-actions';
export const navigateToDashboard = () => set_ui_settings({ dashboard_settings: { selected: true } });
export const navigateToDashboardNotifications = (selected) => set_ui_settings({ dashboard_settings: { events_selected: selected ? false : true } });
export const leaveFromDashboard = () => set_ui_settings({
    dashboard_settings: { selected: false, events_selected: false },
});
